module.exports = __webpack_public_path__ + "img/flecha-hacia-abajo (1).23486f4a.png";